var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3561 23.1943L27.0516 11.8453L28.3291 9.6487V8.91577H7.88867V9.6487L10.4448 18.1605V24.5979",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7735 25.2686L7.76085 16.8505L2.78073 9.64795H0.863281",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4453 26.9772V28.4851C10.4453 29.1206 10.6655 29.7301 11.0576 30.1795C11.4496 30.6289 11.9813 30.8814 12.5357 30.8814C12.988 30.8814 13.4281 30.7132 13.7899 30.4021L21.5694 23.1942",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0509 27.2204C27.7564 27.2204 28.3283 26.5648 28.3283 25.756C28.3283 24.9473 27.7564 24.2916 27.0509 24.2916C26.3454 24.2916 25.7734 24.9473 25.7734 25.756C25.7734 26.5648 26.3454 27.2204 27.0509 27.2204Z",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.522 30.8823H0.863281",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0511 30.1501C29.1676 30.1501 30.8834 28.1832 30.8834 25.7569C30.8834 23.3307 29.1676 21.3638 27.0511 21.3638C24.9345 21.3638 23.2188 23.3307 23.2188 25.7569C23.2188 28.1832 24.9345 30.1501 27.0511 30.1501Z",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7727 8.91644L18.108 0.862305L10.4434 8.91644",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76758 11.8452H16.1927",
    stroke: "#EEEBE7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon05);
export default __webpack_public_path__ + "static/media/icon05.33def50aacbec3a9a41049abb84fca3f.svg";
export { ForwardRef as ReactComponent };